import { useEffect, useState } from "react";
import contribuicoes from "./contribuicoes.json";

interface Props {
  initialState: Record<string, boolean>;

  setContribuicaoNormalParticipante: (v: boolean) => void;
  setContribuicaoNormalAssistido: (v: boolean) => void;
  setContribuicaoNormalPatrocinador: (v: boolean) => void;

  setContribuicaoPDespesasAdministrativasParticipante: (v: boolean) => void;
  setContribuicaoPDespesasAdministrativasAssistido: (v: boolean) => void;
  setContribuicaoPDespesasAdministrativasPatrocinador: (v: boolean) => void;

  setContribuicaoPServicoPassadoParticipante: (v: boolean) => void;
  setContribuicaoPServicoPassadoAssistido: (v: boolean) => void;
  setContribuicaoPServicoPassadoPatrocinador: (v: boolean) => void;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

export default function FormContribuicao(props: Props) {
  // Internal state for UI
  const [checks, setChecks] = useState<Record<string, boolean>>({});

  useEffect(() => {
    setChecks(props.initialState || {});
  }, [props.initialState]);

  // Map JSON "title + label" → your setter function
  const setterMap: Record<string, (v: boolean) => void> = {
    "Contribuição Normal-Participante": props.setContribuicaoNormalParticipante,
    "Contribuição Normal-Assistido": props.setContribuicaoNormalAssistido,
    "Contribuição Normal-Patrocinador": props.setContribuicaoNormalPatrocinador,

    "Contribuição p/ Despesas Administrativas-Participante": props.setContribuicaoPDespesasAdministrativasParticipante,
    "Contribuição p/ Despesas Administrativas-Assistido": props.setContribuicaoPDespesasAdministrativasAssistido,
    "Contribuição p/ Despesas Administrativas-Patrocinador": props.setContribuicaoPDespesasAdministrativasPatrocinador,

    "Contribuição p/ Serviço Passado-Participante": props.setContribuicaoPServicoPassadoParticipante,
    "Contribuição p/ Serviço Passado-Assistido": props.setContribuicaoPServicoPassadoAssistido,
    "Contribuição p/ Serviço Passado-Patrocinador": props.setContribuicaoPServicoPassadoPatrocinador,
  };

  const handleCheck = (key: string, checked: boolean) => {
    setChecks(prev => ({ ...prev, [key]: checked }));

    // Trigger your real setter
    if (setterMap[key]) {
      setterMap[key](checked);
    }
  };

  return (
    <div style={{ display: "flex", gap: "40px" }}>
      {Object.entries(contribuicoes).map(([titulo, itens]) => (
        <div key={titulo}>
          <h4>{titulo}</h4>

          {Object.entries(itens).map(([id, { label }]) => {
            const key = `${titulo}-${label}`;
            const checked = checks[key] || false;

            return (
              <div key={id}>
                <label>
                  <input
                    disabled={props.manter && props.manter === 2 ? true : false}
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => handleCheck(key, e.target.checked)}
                  />
                  {label}
                </label>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
